import Account from "./account";
import Trade from "./trade";
import WorkOrderPriority from "./workOrderPriority";
import WorkOrderStatus from "./workOrderStatus";
import Location from "./location";
import WorkOrderType from "./workOrderType";
import WorkOrderFromToType from "./workOrderFromToType";
import WorkOrderTimeToComplete from "./workOrderTimeToComplete";
import Survey from "./survey";
import ServiceProvider from "./serviceProvider";
import User from "./user";

export default class WorkOrder {
  public idWorkOrder: number = 0;
  public idAccount: number = 0;
  public idLocation: number = 0;
  public idTrade: number = 0;
  public idFromAccount: number | undefined;
  public idFromServiceProvider: number | undefined;
  public idToServiceProvider: number | undefined;
  public idReporterUser: number | undefined;
  public idAssignedUser: number | undefined;
  public idParentWorkOrder: number | undefined;
  public fromType: WorkOrderFromToType = WorkOrderFromToType.None;
  public toType: WorkOrderFromToType = WorkOrderFromToType.None;
  public createDate: Date = new Date();
  public workOrderNumber: string = "";
  public workOrderType: WorkOrderType = WorkOrderType.None;
  public workOrderPriority: WorkOrderPriority = WorkOrderPriority.None;
  public dneAmount: number = 0;
  public dueDate: Date | undefined;
  public estimatedLaborHours: number | undefined;
  public referenceNumber: string | undefined;
  public tags: string | undefined;
  public scopeOfWork: string = "";
  public scheduledDate: Date | undefined;
  public timeToComplete: WorkOrderTimeToComplete = WorkOrderTimeToComplete.None;
  public workOrderStatus: WorkOrderStatus = WorkOrderStatus.None;
  public declineReason: string | undefined;

  public account: Account = new Account();
  public location: Location = new Location();
  public trade: Trade = new Trade();
  public survey: Survey | undefined;
  // public List<Asset> Assets { get; set; } = [];
  public files: File[] = [];
  public fromAccount: Account | undefined;
  public fromServiceProvider: ServiceProvider | undefined;
  public toServiceProvider: ServiceProvider | undefined;

  public entityName: string = "";
  public parentWorkOrder: WorkOrder | null = null;
  public parentWorkOrderNumber: string = "";
  public parentEntityName: string = "";
  public parentEntityIsPublic: boolean = false;
  public childrenWorkOrders: WorkOrder[] = [];

  public canDispatch: boolean = false;
  public canSeeDispatches: boolean = false;

  public reporterUser: User | undefined;
  public assignedUser: User | undefined;
}
